import React from 'react';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';

export default function Title() {
  return (
    <AccentH5 tag="h2" className={uppercase}>
      Shipping
    </AccentH5>
  );
}
